import firebase from "firebase";

import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE } from "../constants/actionTypes";

export function loginRequest(email, password) {
  return dispatch => {
    dispatch({ type: LOGIN_REQUEST });

    return firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        return firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then(async snapshot => {
            let admins = await firebase
              .database()
              .ref("Admin/0/emails")
              .once("value");
            if (admins.val().includes(email)) {
              let universityFirebaseName = await firebase
                .database()
                .ref("Admin/0/universityFirebaseName")
                .once("value");
                
              dispatch(loginSuccess(universityFirebaseName.val()));
            } else {
              throw new Error("คุณไม่มีสิทธิ์เข้าถึงข้อมูล");
            }
          });
      })
      .catch(function(error) {
        dispatch(loginFailure(error));
      });
  };
}

export const loginSuccess = universityFirebase => ({
  type: LOGIN_SUCCESS,
  universityFirebase: universityFirebase
});

export const loginFailure = error => ({
  type: LOGIN_FAILURE,
  error
});

export function logoutRequest() {
  return dispatch => {
    dispatch({ type: LOGOUT_REQUEST });
    firebase
      .auth()
      .signOut()
      .then(
        () => {
          dispatch({ type: LOGOUT_SUCCESS });
        },
        error => {
          dispatch({ type: LOGOUT_FAILURE, error });
        }
      );
  };
}

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS
});

export const logoutFailure = error => ({
  type: LOGOUT_FAILURE,
  error
});



// WEBPACK FOOTER //
// /src/actions/login.js